__turbopack_context__.v({
  "bottomBlend": "FansHeroImageLayers-module-scss-module__Ugn9zG__bottomBlend",
  "darken": "FansHeroImageLayers-module-scss-module__Ugn9zG__darken",
  "grainNoise": "FansHeroImageLayers-module-scss-module__Ugn9zG__grainNoise",
});
